// extracted by mini-css-extract-plugin
export default {"deleteDialog":"DeleteDialog_deleteDialog__ip3td"};